import React, { useEffect, useState } from 'react'
import Api from '../../../../services/Api'
import { INFDetailFormatted } from '../../components/NFTDetail/INFTDetail'
import NFTImageSkeleton from '../../components/NFTImageSkeleton'
import INFTProperties from '../../models/INFTProperties'
import { IHeroesOfNFTCard } from '../Cards/HeroesOfNFTCard'
import BaseDetail from './BaseDetail'


export default function HeroesOfNFTDetail(props: INFDetailFormatted) {
  const { tokenItem, collection } = props
  const [detailTokenItem, setDetailTokenItem] = useState<IHeroesOfNFTCard | null>(null)
  const [tokenUriControl, setTokenUriControl] = useState<boolean>(false)
  const tokenName = detailTokenItem ? `${detailTokenItem.name} #${tokenItem.tokenId}` : collection.name
  const tokenImage = detailTokenItem ? detailTokenItem.imageGateway : ''
  useEffect(() => {
    if (tokenItem && tokenItem.tokenId !== undefined && tokenItem.tokenUri && !tokenUriControl) {
      setTokenUriControl(true)
      Api.get(tokenItem.tokenUri).then((tokenResult: any) => setDetailTokenItem(tokenResult))
    }
  }, [tokenItem, tokenUriControl])

  function getNFTDescription() {
    return (
      <div>
        What is Heroes of NFT?
        <p>
          Heroes of Nft is a turn-based collectable trading card game. Players can battle in the arena against each
          other and show-off their skills with unique hero cards. Our novel Play 2 Earn mechanics will allow players to
          be participants of a real game economy. PvP and PvE modes are rewarded separately with mintable HRM tokens
          while the real prizes are distributed in the official tournaments. Last but not least, Virtual Reality and
          Augmented Reality Technologies will soon be integrated into Heroes of NFT
        </p>
      </div>
    )
  }

  function getNFTProperties() {
    let result: INFTProperties[] = []

    if (detailTokenItem) {
      result = [
        {
          key: 'Class',
          value: detailTokenItem.class,
          isUrl: false,
          show: true
        },
        {
          key: 'Rarity',
          value: detailTokenItem.rarity,
          isUrl: false,
          show: true
        },
        {
          key: 'Attack Defence Ratio',
          value: detailTokenItem.adRatio.toString(),
          isUrl: false,
          show: true
        }
      ]
    }

    return result
  }

  return (
    <BaseDetail
      {...props}
      tokenItemName={tokenName}
      properites={getNFTProperties()}
      description={getNFTDescription()}
      externalUrl="https://www.heroesofnft.com/"
    >
      {detailTokenItem ? <img src={tokenImage} alt={tokenName} /> : <NFTImageSkeleton />}
    </BaseDetail>
  )
}
